import {Component, Input, Output, EventEmitter, HostBinding, OnInit, AfterViewInit} from '@angular/core';
import {AbnormalTableComponent} from '../../../../components/main-table/abnormal-table/abnormal-table.component';
import {
    ProductLogicsMainDependenciesList,
    ProductLogicOptionsEnum,
    ProductDescriptionModel,
    ProductLogicsMainProductForDependent
} from '../../model/model';
import {SnackbarService, GeneralService} from '../../../../core';
import {Router} from '@angular/router';
import {ProductLogicsModalComponent} from './product-logics-modal/product-logics-modal.component';
import {ProductsDataService} from '../../services/products.data.service';
import {finalize} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {BaseTable} from '../../../../components/new-table/base-table';
import {TableColumnDef} from '../../../../shared/tables/table-column-def';

@Component({
    selector: 'product-logics-default',
    template: `
        <div class="mv-xs">
            <p>Dla danego produktu obecnie nie ma zdefiniowanych powiązań produktowych.</p>
        </div>
        <div class="mv-xs">
            <a class="text-button" (click)="setAsMain()">Zdefiniuj SKU jako SKU Główny</a>
        </div>
    `,
    styleUrls: []
})
export class ProductLogicsDefaultComponent {
    @Input() productId: number;
    @Output() changeType: EventEmitter<any> = new EventEmitter();

    constructor(
        private snackbar: SnackbarService,
        private dataService: ProductsDataService
    ) {
    }

    public setAsMain() {
        this.dataService.setProductAsMain(this.productId)
            .subscribe(
                response => {
                    this.snackbar.info('Produkt został oznaczony jako główny.');
                    this.changeType.emit(ProductLogicOptionsEnum.main);
                },
                err => this.snackbar.info('Nie udało się ustawić produkt jako główny.')
            );
    }
}

@Component({
    selector: 'product-logics-dependent',
    template: `
        <div class="mv-xxs">
            <h3>Ten SKU jest obecnie zdefiniowany jako SKU zależny dla:</h3>
        </div>
        <div class="mv-xxs">
            <a (click)="navigateToMain()" class="text-button">{{ productName }}</a>
        </div>
    `,
    styleUrls: []
})
export class ProductLogicsDependentComponent implements OnInit {

    @Input() productId: number;

    mainProduct: ProductLogicsMainProductForDependent = null;

    constructor(
        public router: Router,
        public dataService: ProductsDataService
    ) {
    }

    ngOnInit() {
        this.loadMainForDependent();
    }

    public loadMainForDependent() {
        this.dataService.getMainForDependent(this.productId)
            .subscribe(
                product => this.mainProduct = product
            );
    }

    get productName(): string {
        return this.mainProduct ? this.mainProduct.Name : null;
    }

    public navigateToMain(): void {
        this.router.navigate(['metadata', 'articles', 'add', this.mainProduct.Id.toString()]);
    }
}

@Component({
    selector: 'product-logics-main',
    templateUrl: './product-logics-main.component.html',
    styleUrls: ['../../../../components/main-table/main-table.component.scss']
})
export class ProductLogicsMainComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow';

    @Input() product: ProductDescriptionModel;
    @Output() changeType: EventEmitter<any> = new EventEmitter();

    tableData: [];
    columnsData: TableColumnDef[];
    tableId: string;
    isLoadingResults = false;

    pageSize = 10;
    originSelectedProducts: ProductLogicsMainDependenciesList[] = [];

    constructor(
        private snackBar: SnackbarService,
        public generalService: GeneralService,
        public router: Router,
        public dialog: MatDialog,
        public dataService: ProductsDataService
    ) {
    }

    ngOnInit() {
        const tableInfo = ProductLogicsMainDependenciesList.tableInfo();
        this.columnsData = tableInfo.columns;
        this.tableId = tableInfo.tableId;

        this.loadDependencies();
    }

    public toogleEdition() {
        const dialogRef = this.dialog.open(ProductLogicsModalComponent, {
            width: '90%',
            data: {
                products: this.tableData,
                product: this.product
            },
            disableClose: true
        });

        dialogRef.afterClosed()
            .subscribe(
                result => {
                    if (result && result.close) {
                        this.loadDependencies();
                    }
                }
            );
    }

    private loadDependencies(): void {
        this.isLoadingResults = true;
        this.dataService.getMainProductDependencies(this.product.Id)
            .pipe(finalize(() => this.isLoadingResults = false))
            .subscribe(
                products => {
                    this.tableData = products.items;
                    // we need original products list from API
                    this.originSelectedProducts = products.items;
                },
                logErr => {
                    console.log(logErr);
                }
            );
    }

    unsetAsMain() {
        this.dataService.unsetProductAsMain(this.product.Id)
            .subscribe(
                response => {
                    this.snackBar.info('Produkt został odznaczony jako główny.');
                    this.changeType.emit(ProductLogicOptionsEnum.default);
                },
                err => {
                    // TODO: check if all dependencies are deleted
                    this.snackBar.info('Nie udało się odznaczyć produktu jako główny.');
                }
            );
    }
}
